
import { AxiosError } from 'axios';
import environment from '../../../../environments/environment';
import { axiosInterceptor } from '../authInterceptor';
import testData from '../DummyJson/financials/financialsList.json';
import { AdminBudgetSearch, BudgetSearch, CoverSheetActualVO, DocumentsVO, FinancialReportActualVO, FiscalExternalAccountSystemVORequest, ForecastChartIdReq, ForecastLockDateVO, MasterChartAccountsVO, ParticipantForecastExceptionsVO, SchoolBudgetFormVO, SubChartTransActualRequest, SubChartTransForecastRequest } from './financials';


const FORCASTLIST_FILTER_URL = environment.getForcastListURL;
const FORCASTLIST_COUNT_URL = environment.getForcastListCountURL;
const FORCASTLIST_STATUS_FILTER_URL = environment.getParticipantForecastStatusListURL;
const FORCASTLIST_STATUS_COUNT_URL = environment.getParticipantForecastStatusCountURL;
const CHAT_ACCOUNTS_BY_YEAR_AND_PARTICIPANTID_URL = environment.getForecastChartAccountsByYearAndParticipantIdURL;
const GET_BUDGET_FORECAST_ELIGIBLE_YEAR_BY_PARTICIPANTID_YEAR_URL = environment.getBudgetForecastEligibleYearByParticipantIdAndYearURL;
const GET_PARTICIPANT_FORCAST_STATUS_PARTICIPANTID_FINANCIAL_YEAR_URL = environment.getParticipantForecastStatusByParticipantIdAndFinancialYearURL;
const GET_ALL_FINANCIAL_YEAR_URL = environment.getAllFinancialYearsUrl;

const GET_BUDGET_ACTUAL_ELIGIBLE_MONTHS_BY_PARTICIPANTID_URL = environment.getBudgetActualEligibleMonthsByParticipantIdURL;
const GET_BUDGET_FORECAST_ELIGIBLE_YEAR_BY_PARTICIPANTID_URL = environment.getBudgetForecastEligibleYearByParticipantIdURL;
const GET_FORECAST_MAPPING_DETAILS_BY_FINANCIAL_YEAR_AND_PARTICIPANTID_URL = environment.getForecastMappingDetailsByFinancialYearAndParticipantIdURL;
const GET_FORECAST_MAPPING_DETAILS_BY_FINANCIAL_YEAR_AND_PARTICIPANTID_ONE_URL = environment.getForecastMappingDetailsByFinancialYearAndParticipantIdURL1;
const GET_PARTICIPANT_FILE_MAPPING_BY_PARTICIPANTID_TYPE_URL = environment.getParticipantFileMappingByParticipantIdTypeURL;
const GET_BUDGET_ACTUAL_ELIGIBLE_MONTHS_BY_YEAR_URL = environment.getBudgetActualEligibleMonthsByYearURL;
const GET_BUDGET_DETAILS_TO_DOWNLOAD = environment.getBudgetDetailsTODownloadURL;

const GET_DETAILS_BY_TYPE_YEAR_URL = environment.getDetailsByTypeYearURL;
const GET_DETAILS_BY_YEAR_AND_LOCATION_ID_URL = environment.getDetailsByYearandLocationIdURL;
const GET_BR_PDF_BY_YEAR_AND_LOCATION_URL = environment.getBRPdfByYearAndLocationURL;
const GET_DISABLE_FR_FIELDS_URL = environment.getDisableFRFieldsURL;
const GET_FR_PDF_BY_YEAR_AND_LOCATION_URL = environment.getFRPdfByYearAndLocationURL;
const GET_BUDGET_DOCUMENT_DETAILS_BY_YEAR_AND_LOCATION_ID_URL = environment.getBudgetDocumentDetailsByYearAndLocationIdURL;
const GET_FINANCIAL_REPORT_DETAILS_BY_TYPE_YEAR_URL = environment.getFinancialReportDetailsByTypeYearURL;
const GET_FINANCIAL_REPORT_DETAILS_BY_YEAR_AND_LOCATION_ID_URL = environment.getFinancialReportDetailsByYearandLocationIdURL;
const GET_BUDGET_DOCUMENT_DOWNLOAD_URL = environment.getBudgetDocumentDownloadURL;
const SAVE_FINANCIAL_REPORT_ACTUAL_DETAILS_URL = environment.saveFinancialReportActualDetailsURL;
const SAVE_ACTUAL_DETAILS_URL = environment.saveActualDetailsURL;
const DELETE_AND_REMOVE_DOCUMENT_DETAILS_URL = environment.deleteAndRemoveDocumentDetatilsURL;
const UPLOAD_AND_POST_DOCUMENT_URL = environment.uploadAndPostDocumentURL;
const UPDATE_STATUS_AND_FORECAST_SUBMISSION_DATE_BY_PARTICIPANTID_AND_FINANCIAL_YEAR_URL = environment.updateStatusAndForecastSubmissionDateByParticipantIdAndFinancialYearURL;
const GET_FINANCIAL_YEAR_URL = environment.getFinancialYearsURL;
const GET_PARTICIPANT_FORECAST_EXCEPTIONS_BY_FY_YEAR_PARTICIPANT_URL = environment.getparticipantForecastExceptionsByFyYearParticipantURL;
const GET_FORECAST_LOCK_DATE_BY_FY_YEAR_URL = environment.getforecastLockDateByFyYearURL;
const CHECK_FORECAST_CHART_ACCOUNTS_EXIST_URL = environment.checkForecastChartAccountsExistURL;
const REPLACE_CHART_ACCOUNTS_DETAILS_URL = environment.replaceChartAccountDetailsURL;
const GET_PARISH_BUDGET_FORM_BY_FINANIAL_YEAR_URL = environment.getParishBudgetFormByFinancialYearURL;
const ADD_MASTER_CHART_ACCOUNTS_URL = environment.addMasterChartAccountsURL;
const POST_PARTICIPANT_FORECAST_EXCEPTIONS_URL = environment.postParticipantForecastExceptionsURL;
const POST_FORECAST_LOCK_DATE_URL = environment.postForecastLockDateURL;
const COPY_CHART_ACCOUNT_DETAILS_BY_YEAR_URL = environment.copychartAccountDetailsByYearURL;
const DELECT_MASTER_CHART_ACCOUNTS_BY_ID_URL = environment.deleteMasterChartAccountsByIdUrl;
const PUBLISH_CHART_ACCOUNT_DETAILS_URL = environment.publishChartAccountDetailsUrl;
const GET_CHART_ACCOUNT_DETAILS_BY_YEAR_URL = environment.getChartAccountDetailsByYearUrl;
const DELECT_SUB_CHART_ACCOUNTS_BY_ID_URL = environment.deleteSubChartAccountsByIdUrl;
const POST_FORECAST_CHART_ACCOUNTS_TRANSACTIONS_URL = environment.postForecastChartAccountsTransactionsURL;
const POST_SCHOOL_BUDGET_FORM_URL = environment.postSchoolBudgetFormURL;
const POST_FISCAL_EXTERNAL_ACCOUNT_SYSTEM_SUB_CHART_ACCOUNTS_TRANSACTIONS_URL = environment.postFiscalExternalAccountSystemSubChartAccountsTransactionsURL;
const SAVE_FISCAL_EXTERNAL_ACCOUNT_SYSTEM_URL = environment.saveFiscalExternalAccountSystemURL;
const POST_FISCAL_EXTERNAL_ACCOUNT_SYSTEM_SUB_CHART_ACCOUNTS_TRANSACTIONS_FORECAST_URL = environment.postFiscalExternalAccountSystemSubChartAccountsTransactionsForecastURL;

export async function getBudgetSearchCount(budgetSearch: BudgetSearch) {
  try {
    const countResponse = await axiosInterceptor.post(`${FORCASTLIST_COUNT_URL}`, budgetSearch);
    return countResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function getBudgetInfoList(budgetSearch: BudgetSearch) {
  try {
    const getAllBudgetInfoListResponse = await axiosInterceptor.post(`${FORCASTLIST_FILTER_URL}`, budgetSearch);
    return getAllBudgetInfoListResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}
export async function getAdminBudgetSearchCount(budgetSearch: AdminBudgetSearch) {
  try {
    const countResponse = await axiosInterceptor.post(`${FORCASTLIST_STATUS_COUNT_URL}`, budgetSearch);
    return countResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function getAdminBudgetInfoList(budgetSearch: AdminBudgetSearch) {
  try {
    const getAllAdminBudgetInfoListResponse = await axiosInterceptor.post(`${FORCASTLIST_STATUS_FILTER_URL}`, budgetSearch);
    return getAllAdminBudgetInfoListResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function getChartAccountsByYearAndParticipantIdURL(forecastYear: string, participantId: number, clientId: number) {
  try {
    const getChartAccountsByYearAndParticipantIdResponse = await axiosInterceptor.get(`${CHAT_ACCOUNTS_BY_YEAR_AND_PARTICIPANTID_URL}${forecastYear}/participant-id/${participantId}?clientId=${clientId}`);
    return getChartAccountsByYearAndParticipantIdResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}
export async function getBudgetForecastEligibleYearByParticipantIdAndYear(participantId: number, financialYear: number, clientId: number) {
  try {
    const getBudgetForecastEligibleYearByParticipantIdAndYearResponse = await axiosInterceptor.get(`${GET_BUDGET_FORECAST_ELIGIBLE_YEAR_BY_PARTICIPANTID_YEAR_URL}${participantId}/financial-year/${financialYear}?clientId=${clientId}`);
    return getBudgetForecastEligibleYearByParticipantIdAndYearResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}
export async function getParticipantForecastStatusByParticipantIdAndFinancialYear(participantId: number, financialYear: string, clientId: number) {
  try {
    const getParticipantForecastStatusResponse = await axiosInterceptor.get(`${GET_PARTICIPANT_FORCAST_STATUS_PARTICIPANTID_FINANCIAL_YEAR_URL}${participantId}/financial-year/${financialYear}?clientId=${clientId}`);
    return getParticipantForecastStatusResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}
export async function getAllFinancialYear(type: number, clientId: number) {
  try {
    const getAllFinancialYearResponse = await axiosInterceptor.get(`${GET_ALL_FINANCIAL_YEAR_URL}${type}?clientId=${clientId}`);
    return getAllFinancialYearResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}
export async function getBudgetActualEligibleMonthsByParticipantId(participantId: number, clientId: number) {
  try {
    const getBudgetActualEligibleMonthsByParticipantIdResponse = await axiosInterceptor.get(`${GET_BUDGET_ACTUAL_ELIGIBLE_MONTHS_BY_PARTICIPANTID_URL}${participantId}?clientId=${clientId}`);
    return getBudgetActualEligibleMonthsByParticipantIdResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function getBudgetForecastEligibleYearByParticipantId(participantId: number, clientId: number) {
  try {
    const getBudgetForecastEligibleYearByParticipantIdResponse = await axiosInterceptor.get(`${GET_BUDGET_FORECAST_ELIGIBLE_YEAR_BY_PARTICIPANTID_URL}${participantId}?clientId=${clientId}`);
    return getBudgetForecastEligibleYearByParticipantIdResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}
export async function getForecastMappingDetailsByFinancialYearAndParticipantId(eligibleYear: string, participantId: number, type: string, clientId: number) {
  try {
    const getForecastMappingDetailsByFinancialYearAndParticipantIdResponse = await axiosInterceptor.get(`${GET_FORECAST_MAPPING_DETAILS_BY_FINANCIAL_YEAR_AND_PARTICIPANTID_URL}${eligibleYear}/participant-id/${participantId}/type/${type}?clientId=${clientId}`);
    return getForecastMappingDetailsByFinancialYearAndParticipantIdResponse;
    //return testData.importChartAccountsMappingVOList;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function getForecastMappingDetailsByFinancialYearsAndParticipantId(type: number, clientId: number) {
  try {
    const getForecastMappingDetailsByFinancialYearsAndParticipantIdResponse = await axiosInterceptor.get(`${GET_FORECAST_MAPPING_DETAILS_BY_FINANCIAL_YEAR_AND_PARTICIPANTID_ONE_URL}${type}?clientId=${clientId}`);
    return getForecastMappingDetailsByFinancialYearsAndParticipantIdResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}
export async function getParticipantFileMappingByParticipantIdType(participantId: number, type: string, formatType: string, clientId: number) {
  try {
    const getParticipantFileMappingByParticipantIdTypeResponse = await axiosInterceptor.get(`${GET_PARTICIPANT_FILE_MAPPING_BY_PARTICIPANTID_TYPE_URL}${participantId}/type/${type}/format/${formatType}?clientId=${clientId}`);
    return getParticipantFileMappingByParticipantIdTypeResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function getBudgetActualEligibleMonthsByYear(participantId: number, financialYear: string, clientId: number) {
  try {
    const getBudgetActualEligibleMonthsByYearResponse = await axiosInterceptor.get(`${GET_BUDGET_ACTUAL_ELIGIBLE_MONTHS_BY_YEAR_URL}participant-id/${participantId}/financial-year/${financialYear}?clientId=${clientId}`);
    return getBudgetActualEligibleMonthsByYearResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}
export async function getDetailsByTypeYear(financialYear: string, type: string, clientId: number) {
  try {
    const getDetailsByTypeYearResponse = await axiosInterceptor.get(`${GET_DETAILS_BY_TYPE_YEAR_URL}/${financialYear}/type/${type}?clientId=${clientId}`);
    return getDetailsByTypeYearResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function getFRPdfByYearAndLocation(financialYear: string, locationId: number, clientId: number) {
  try {
    const getFRPdfByYearAndLocationResponse = await axiosInterceptor.get(`${GET_FR_PDF_BY_YEAR_AND_LOCATION_URL}${financialYear}/location/${locationId}?clientId=${clientId}`);
    return getFRPdfByYearAndLocationResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}
export async function getFinancialReportDetailsByYearandLocationId(financialYear: string, locationId: number, clientId: number) {
  try {
    const getFinancialReportDetailsByYearandLocationIdResponse = await axiosInterceptor.get(`${GET_FINANCIAL_REPORT_DETAILS_BY_YEAR_AND_LOCATION_ID_URL}/${financialYear}/location/${locationId}?clientId=${clientId}`);
    return getFinancialReportDetailsByYearandLocationIdResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}
export async function getBRPdfByYearAndLocation(financialYear: string, locationId: number, clientId: number) {
  try {
    const getBRPdfByYearAndLocationResponse = await axiosInterceptor.get(`${GET_BR_PDF_BY_YEAR_AND_LOCATION_URL}${financialYear}/location/${locationId}?clientId=${clientId}`);
    return getBRPdfByYearAndLocationResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}
export async function getDetailsByYearandLocationId(financialYear: string, locationId: number, clientId: number) {
  try {
    const getDetailsByYearandLocationIdResponse = await axiosInterceptor.get(`${GET_DETAILS_BY_YEAR_AND_LOCATION_ID_URL}/${financialYear}/location/${locationId}?clientId=${clientId}`);
    return getDetailsByYearandLocationIdResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}
export async function getDisableFRFields(financialYear: string, clientId: number) {
  try {
    const getDisableFRFieldsResponse = await axiosInterceptor.get(`${GET_DISABLE_FR_FIELDS_URL}${financialYear}?clientId=${clientId}`);
    return getDisableFRFieldsResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}
export async function getBudgetDocumentDetailsByYearAndLocationId(financialYear: string, locationId: number, type: string, clientId: number) {
  try {
    const getBudgetDocumentDetailsByYearAndLocationIdResponse = await axiosInterceptor.get(`${GET_BUDGET_DOCUMENT_DETAILS_BY_YEAR_AND_LOCATION_ID_URL}${financialYear}/location/${locationId}/type/${type}?clientId=${clientId}`);
    return getBudgetDocumentDetailsByYearAndLocationIdResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}
export async function getFinancialReportDetailsByTypeYear(financialYear: string, type: string, clientId: number) {
  try {
    const getFinancialReportDetailsByTypeYearResponse = await axiosInterceptor.get(`${GET_FINANCIAL_REPORT_DETAILS_BY_TYPE_YEAR_URL}/${financialYear}/type/${type}?clientId=${clientId}`);
    return getFinancialReportDetailsByTypeYearResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}
export async function getBudgetDocumentDownload(filePath: string, clientId: number) {
  try {
    const getBudgetDocumentDownloadResponse = await axiosInterceptor.get(`${GET_BUDGET_DOCUMENT_DOWNLOAD_URL}/${filePath}&clientId=${clientId}`);
    return getBudgetDocumentDownloadResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function getBudgetDetailsToDownload(financialYear: string, participantId: number, clientId: number) {
  try {
    const getBudgetDetailsToDownloadResponse = await axiosInterceptor.get(`${GET_BUDGET_DETAILS_TO_DOWNLOAD}${financialYear}/participant-id/${participantId}?clientId=${clientId}`);
    return getBudgetDetailsToDownloadResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}
export async function updateStatusAndActualSubmissionDateByParticipantIdAndFinancialYear(status: string, participantId: number, financialYear: string) {
  try {
    const updateStatusAndActualSubmissionDateByParticipantIdAndFinancialYearResponse = await axiosInterceptor.post(`${UPDATE_STATUS_AND_FORECAST_SUBMISSION_DATE_BY_PARTICIPANTID_AND_FINANCIAL_YEAR_URL}${status}/participant-id/${participantId}/financial-year/${financialYear}`);
    return updateStatusAndActualSubmissionDateByParticipantIdAndFinancialYearResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}
export async function getFinancialYear(clientId: number) {
  try {
    const getFinancialYearResponse = await axiosInterceptor.get(`${GET_FINANCIAL_YEAR_URL}?clientId=${clientId}`);
    return getFinancialYearResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function participantForecastExceptionsByFyYearParticipant(financialYear: string, participantId: number, clientId: number) {
  try {
    const participantForecastExceptionsByFyYearParticipantResponse = await axiosInterceptor.get(`${GET_PARTICIPANT_FORECAST_EXCEPTIONS_BY_FY_YEAR_PARTICIPANT_URL}${financialYear}/participant-id/${participantId}?clientId=${clientId}`);
    return participantForecastExceptionsByFyYearParticipantResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}
export async function forecastLockDateByFyYear(financialYear: string, clientId: number) {
  try {
    const forecastLockDateByFyYearResponse = await axiosInterceptor.get(`${GET_FORECAST_LOCK_DATE_BY_FY_YEAR_URL}${financialYear}?clientId=${clientId}`);
    return forecastLockDateByFyYearResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function checkForecastChartAccountsExist(financialYear: string, type: number, clientId: number) {
  try {
    const checkForecastChartAccountsExistResponse = await axiosInterceptor.get(`${CHECK_FORECAST_CHART_ACCOUNTS_EXIST_URL}/financial-year/${financialYear}/type/${type}?clientId=${clientId}`);
    return checkForecastChartAccountsExistResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function replaceChartAccountDetails(year: string, budgetYear: string, type: number ) {
  try {
    const replaceChartAccountDetailsResponse = await axiosInterceptor.post(`${REPLACE_CHART_ACCOUNTS_DETAILS_URL}/${year}/budget-year/${budgetYear}/type/${type}`);
    return replaceChartAccountDetailsResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function getParishBudgetFormByFinancialYear(financialYear: string, clientId: number) {
  try {
    const getParishBudgetFormByFinancialYearResponse = await axiosInterceptor.get(`${GET_PARISH_BUDGET_FORM_BY_FINANIAL_YEAR_URL}${financialYear}?clientId=${clientId}`);
    return getParishBudgetFormByFinancialYearResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function addMasterChartAccounts(masterChartAccountsVO: MasterChartAccountsVO) {
  try {
    const addMasterChartAccountsResponse = await axiosInterceptor.post(`${ADD_MASTER_CHART_ACCOUNTS_URL}`, masterChartAccountsVO);
    return addMasterChartAccountsResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function postParticipantForecastExceptions(participantForecastExceptionsVO: ParticipantForecastExceptionsVO) {
  try {
    const postParticipantForecastExceptionsResponse = await axiosInterceptor.post(`${POST_PARTICIPANT_FORECAST_EXCEPTIONS_URL}`, participantForecastExceptionsVO);
    return postParticipantForecastExceptionsResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function postForecastLockDate(forecastLockDateVO: ForecastLockDateVO) {
  try {
    const postForecastLockDateResponse = await axiosInterceptor.post(`${POST_FORECAST_LOCK_DATE_URL}`, forecastLockDateVO);
    return postForecastLockDateResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}
export async function copychartAccountDetailsByYear(year: string, budgetYear: string, type: number ) {
  try {
    const copychartAccountDetailsByYearResponse = await axiosInterceptor.post(`${COPY_CHART_ACCOUNT_DETAILS_BY_YEAR_URL}/${year}/budget-year/${budgetYear}/type/${type}`);
    return copychartAccountDetailsByYearResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function deleteMasterChartAccounts(id: number, clientId: number) {
  try {
    const deleteMasterChartAccountsResponse = await axiosInterceptor.post(`${DELECT_MASTER_CHART_ACCOUNTS_BY_ID_URL}${id}?clientId=${clientId}`);
    return deleteMasterChartAccountsResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}
export async function publishChartAccountDetails(financialYear: string, type: number, clientId: number) {
  try {
    const publishChartAccountDetailsResponse = await axiosInterceptor.post(`${PUBLISH_CHART_ACCOUNT_DETAILS_URL}/${financialYear}/type/${type}?clientId=${clientId}`);
    return publishChartAccountDetailsResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function getChartAccountDetailsByYear(financialYear: string, type: number, clientId: number) {
  try {
    const getChartAccountDetailsByYearResponse = await axiosInterceptor.get(`${GET_CHART_ACCOUNT_DETAILS_BY_YEAR_URL}/${financialYear}/type/${type}?clientId=${clientId}`);
    return getChartAccountDetailsByYearResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function deleteSubChartAccounts(id: number, clientId: number) {
  try {
    const deleteSubChartAccountsResponse = await axiosInterceptor.post(`${DELECT_SUB_CHART_ACCOUNTS_BY_ID_URL}${id}?clientId=${clientId}`);
    return deleteSubChartAccountsResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function saveFiscalExternalAccountSystem(fiscalExternalAccountSystemVORequest: FiscalExternalAccountSystemVORequest) {
  try {
    const saveFiscalExternalAccountSystemResponse = await axiosInterceptor.post(`${SAVE_FISCAL_EXTERNAL_ACCOUNT_SYSTEM_URL}`, fiscalExternalAccountSystemVORequest);
    return saveFiscalExternalAccountSystemResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function postForecastChartAccountsTransactions(forecastChartIdReq: ForecastChartIdReq) {
  try {
    const postForecastChartAccountsTransactionsResponse = await axiosInterceptor.post(`${POST_FORECAST_CHART_ACCOUNTS_TRANSACTIONS_URL}`, forecastChartIdReq);
    return postForecastChartAccountsTransactionsResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function postFiscalExternalAccountSystemSubChartAccountsTransactions(subChartTransActualRequest: SubChartTransActualRequest) {
  try {
    const postFiscalExternalAccountSystemSubChartAccountsTransactionsResponse = await axiosInterceptor.post(`${POST_FISCAL_EXTERNAL_ACCOUNT_SYSTEM_SUB_CHART_ACCOUNTS_TRANSACTIONS_URL}`, subChartTransActualRequest);
    return postFiscalExternalAccountSystemSubChartAccountsTransactionsResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}
export async function postSchoolBudgetForm(schoolBudgetFormVO: SchoolBudgetFormVO) {
  try {
    const postSchoolBudgetFormResponse = await axiosInterceptor.post(`${POST_SCHOOL_BUDGET_FORM_URL}`, schoolBudgetFormVO);
    return postSchoolBudgetFormResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}
export async function postFiscalExternalAccountSystemSubChartAccountsTransactionsForecast(subChartTransForecastRequest: SubChartTransForecastRequest) {
  try {
    const postFiscalExternalAccountSystemSubChartAccountsTransactionsForecastResponse = await axiosInterceptor.post(`${POST_FISCAL_EXTERNAL_ACCOUNT_SYSTEM_SUB_CHART_ACCOUNTS_TRANSACTIONS_FORECAST_URL}`, subChartTransForecastRequest);
    return postFiscalExternalAccountSystemSubChartAccountsTransactionsForecastResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function saveActualDetails(coverSheetActualVO: CoverSheetActualVO[]) {
  try {
    const saveActualDetailsResponse = await axiosInterceptor.post(`${SAVE_ACTUAL_DETAILS_URL}`, coverSheetActualVO);
    return saveActualDetailsResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}
export async function saveFinanacalReportActualDetails(financialReportActualVO: FinancialReportActualVO[]) {
  try {
    const saveFinanacalReportActualDetailsResponse = await axiosInterceptor.post(`${SAVE_FINANCIAL_REPORT_ACTUAL_DETAILS_URL}`, financialReportActualVO);
    return saveFinanacalReportActualDetailsResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}
export async function deleteAndRemoveDocumentDetatils(documentsVO: DocumentsVO) {
  try {
    const deleteAndRemoveDocumentDetatilsResponse = await axiosInterceptor.post(`${DELETE_AND_REMOVE_DOCUMENT_DETAILS_URL}`, documentsVO);
    return deleteAndRemoveDocumentDetatilsResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}


export async function uploadAndPostDocument(file: File, documentsVO: DocumentsVO) {
  try {
    const uploadAndPostDocumentResponse = await axiosInterceptor.post(`${UPLOAD_AND_POST_DOCUMENT_URL}`, documentsVO);
    return uploadAndPostDocumentResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}